import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { useClientAuctionStore } from '@features/client/auctions/clientAuctionStore.ts';
import AuctionDetail from '@features/client/auctions/AuctionDetail.tsx';
import UserLayout from '@components/layout/UserLayout.tsx';

const paramsSchema = z.object({
  auctionId: z.coerce.number().positive(),
});

const searchSchema = z.object({
  // Aktivní tab
  tab: z.enum(['suppliers', 'products', 'prices']).optional().default('suppliers'),
  // Stránkování
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
  // Filtry
  q: z.string().optional(),
  supplierId: z.coerce.number().optional(),
  // Filtry pro ceny
  productQuery: z.string().optional(),
  priceType: z.enum(['STANDARD', 'ACTION_PRICE', 'SUBSTITUTE_PRICE', 'FROM_DL_PRICE']).optional(),
  guaranteed: z.coerce.boolean().optional(),
});

export const Route = createFileRoute('/c/$orgId/$portalId/auctions/$auctionId')({
  params: {
    parse: v => paramsSchema.parse(v),
  },
  validateSearch: search => searchSchema.parse(search),
  beforeLoad: async ({ params, search }) => {
    const auctionId = paramsSchema.parse(params).auctionId;
    const store = useClientAuctionStore.getState();

    // Načti základní detail aukce
    await store.fetchAuctionDetail(auctionId);

    // Načti všechny záložky paralelně - aktivní tab s parametry z URL, ostatní s výchozími hodnotami
    const { tab, page, size, q, supplierId, productQuery, priceType, guaranteed } = search;

    await Promise.all([
      store.fetchSuppliers(auctionId, tab === 'suppliers' ? { page, size, q } : { page: 1, size: 20 }),
      store.fetchProducts(auctionId, tab === 'products' ? { page, size, q, supplierId } : { page: 1, size: 20 }),
      store.fetchPrices(
        auctionId,
        tab === 'prices'
          ? {
              page,
              size,
              supplierId,
              productQuery,
              priceType,
              isGuaranteed: guaranteed,
            }
          : { page: 1, size: 20 },
      ),
    ]);
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { auctionId } = Route.useParams();
  return (
    <UserLayout>
      <AuctionDetail auctionId={auctionId} />
    </UserLayout>
  );
}
